import { createFileRoute } from '@tanstack/react-router';

import { SelectThreadPanel } from '../-components/empty-states';

export const Route = createFileRoute('/_dashboard/mailbox/incoming/')({
  component: SelectThreadPanel,
});
